// extracted by mini-css-extract-plugin
module.exports = {"blog":"page_blog__hUTvn"};